import type { BeneficiaryIndicatorsPayload } from '@Application/Indicators/Actions/beneficiaryIndicatorsFetched';
import IndicatorComparisonView from '@UI/Store/Indicators/Views/IndicatorComparisonView';
import IndicatorPeriodView from '@UI/Store/Indicators/Views/IndicatorPeriodView';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class BeneficiaryIndicatorsView {
	readonly queryKey: string;
	readonly period: IndicatorPeriodView;
	readonly active: number;
	readonly created: IndicatorComparisonView;

	constructor(payload: BeneficiaryIndicatorsPayload) {
		this.queryKey = payload.queryKey;
		this.period = new IndicatorPeriodView(payload.period);
		this.active = payload.active;
		this.created = new IndicatorComparisonView(payload.created);

		Object.freeze(this);
	}
}

export default BeneficiaryIndicatorsView;
